import { TemplateDeploymentState } from "types/generated";

export const isDeploymentUpdateDisabled = (state: TemplateDeploymentState): boolean => {
  return [
    TemplateDeploymentState.Destroying,
    TemplateDeploymentState.InProgress,
    TemplateDeploymentState.Unconfirmed,
    TemplateDeploymentState.None,
  ].includes(state);
};

export const getUpdateDisabledTooltip = (state: TemplateDeploymentState): string | undefined => {
  switch (state) {
    case TemplateDeploymentState.Destroying:
      return "Cannot update deployment while it is being destroyed";
    case TemplateDeploymentState.InProgress:
      return "Cannot update deployment while it is in progress";
    case TemplateDeploymentState.Unconfirmed:
      return "Cannot update deployment while it is unconfirmed";
    case TemplateDeploymentState.None:
      return "Cannot update deployment while it is in progress";
    case TemplateDeploymentState.DestroyingFailed:
    case TemplateDeploymentState.Discarded:
    case TemplateDeploymentState.Failure:
    case TemplateDeploymentState.Finished:
      return undefined;
  }
};
